import type { IBaseInput, IEmailInput, IMobileInput, ITextarea, ITextInput } from '~/types/inputs';

export type FormStep = {
	id: FORM_STEP_IDS;
	label: string;
};

export enum FORM_STEP_IDS {
	ENTRY_FORM = 'entry_form',
	PERSONAL_DETAILS = 'personal_details',
	RESULT = 'result',
}

const BASE_INPUT: IBaseInput = {
	description: null,
	required: true,
	name: '',
	label: '',
	width: 'full',
};

const FIRST_NAME: ITextInput = {
	...BASE_INPUT,
	type: 'text',
	name: 'first_name',
	label: 'First Name',
};

const LAST_NAME: ITextInput = {
	...BASE_INPUT,
	type: 'text',
	name: 'last_name',
	label: 'Last Name',
};

const EMAIL: IEmailInput = {
	...BASE_INPUT,
	type: 'email',
	name: 'email',
	label: 'Email',
	description: 'Please ensure your email is correct so we can get back to you.',
};

const MOBILE: IMobileInput = {
	...BASE_INPUT,
	type: 'tel',
	name: 'mobile',
	label: 'Mobile',
};

const MESSAGE: ITextarea = {
	...BASE_INPUT,
	type: 'textarea',
	name: 'message',
	label: 'Message',
};

export const CONTACT_FORM_DATA = [FIRST_NAME, LAST_NAME, EMAIL, MOBILE, MESSAGE];
export const UPDATE_DETAILS_FORM = [EMAIL];

export const FORM_STEPS: FormStep[] = [
	{
		label: 'Step 1',
		id: FORM_STEP_IDS.ENTRY_FORM,
	},
	{
		label: 'Step 2',
		id: FORM_STEP_IDS.PERSONAL_DETAILS,
	},
	{
		label: 'Result',
		id: FORM_STEP_IDS.RESULT,
	},
];
